import { Perimeter } from 'vue-kindergarten';
import _find from 'lodash/find';
import _map from 'lodash/map';
import _intersection from 'lodash/intersection';

/* eslint-enable */

export default class BasePerimeter extends Perimeter {

  isFin() {
    if (!this.child || !this.child.roles || !this.child.roles.length) {
      return false;
    }
    return !!_find(this.child.roles, { name: 'fin' });
  }

  isAdmin() {
    if (!this.child || !this.child.roles || !this.child.roles.length) {
      return false;
    }
    return !!_find(this.child.roles, { name: 'admin' });
  }

  isCreator(entity) {
    if (entity) {
      return this.child.id === (entity.user_id || entity.created_by);
    }
    return true;
  }

  isAssignee(entity) {
    if (entity) {
      return this.child.id === (entity.assigned_to || entity.user_id);
    }
    return true;
  }

  isSupervisor(entity) {
    if (entity &&
      ((entity.assigned_to_user && entity.assigned_to_user.supervisors) ||
        (entity.created_by_user && entity.created_by_user.supervisors))
    ) {
      return entity.assigned_to_user.supervisors.filter(item => item.id === this.child.id).length || entity.created_by_user.supervisors.filter(item => item.id === this.child.id).length;
    }
    return false;
  }

  isManager(entity) {
    if (entity) {
      return this.child.id === entity.manager_id;
    }
    return true;
  }

  isFollower(entity) {
    if (entity.followers.length) {
      return !!_find(entity.followers, { id: this.child.id });
    }
    // @todo Dmitry - this was true, but I guess it's better
    // to be default false?
    return false;
  }

  isBaseRole() {
    return !!_find(this.child.roles, { name: 'base' });
  }

  isAgentRole() {
    return !!_find(this.child.roles, { name: 'agent' });
  }

  isProjectRole() {
    const roles = _map(this.child.roles, el => el.name);
    return !!_intersection(roles, ['sls', 'ops', 'log', 'tra', 'cst', 'age', 'spl']).length;
  }

  isOps() {
    const roles = _map(this.child.roles, el => el.name);
    return !!_intersection(roles, ['ops']).length;
  }

  isLog() {
    const roles = _map(this.child.roles, el => el.name);
    return !!_intersection(roles, ['log']).length;
  }

  isSlsOps() {
    const roles = _map(this.child.roles, el => el.name);
    return !!_intersection(roles, ['sls', 'ops']).length;
  }

  isOpsLog() {
    const roles = _map(this.child.roles, el => el.name);
    return !!_intersection(roles, ['log', 'ops']).length;
  }

  isSls() {
    const roles = _map(this.child.roles, el => el.name);
    return !!_intersection(roles, ['sls']).length;
  }

  isTrading() {
    const roles = _map(this.child.roles, el => el.name);
    return !!_intersection(roles, ['trading']).length;
  }

  isPdm() {
    const roles = _map(this.child.roles, el => el.name);
    return !!_intersection(roles, ['pdm']).length;
  }

  isMyHp() {
    const roles = _map(this.child.roles, el => el.name);
    return !!_intersection(roles, ['my-hp']).length;
  }

  isManagement() {
    const roles = _map(this.child.roles, el => el.name);
    return !!_intersection(roles, ['mgt']).length;
  }

  isHRC() {
    const roles = _map(this.child.roles, el => el.name);
    return !!_intersection(roles, ['hrc']).length;
  }

  isMDT() {
    const roles = _map(this.child.roles, el => el.name);
    return !!_intersection(roles, ['mdt']).length;
  }

  isHRV() {
    const roles = _map(this.child.roles, el => el.name);
    return !!_intersection(roles, ['hrv']).length;
  }

  isInternal() {
    return !!_find(this.child.roles, { internal: 1 });
  }
}



// WEBPACK FOOTER //
// ./src/kindergarten/perimeters/BasePerimiter.js